// import useScreenWidth from '@use/useScreenWidth';
import { ref, Ref } from 'vue';

export const screenWidth: Ref<number> = ref(window.innerWidth);
export const screenType: Ref<string> = ref('mobile');
const handlerResize = () => {
  screenWidth.value = window.innerWidth;
  if (window.innerWidth >= 992) {
    screenType.value = 'desktop';
  } else if (window.innerWidth >= 768) {
    screenType.value = 'tablet';
  } else {
    screenType.value = 'mobile';
  }
};
handlerResize();

window.addEventListener('resize', handlerResize);

export const isIphone: boolean = /^(iPhone|iPad|iPod)/.test(navigator.platform);
